// Mock data for Autogutachter24

export const features = [
  { id: 1, text: "DAT myClaim Integration" },
  { id: 2, text: "Automatische Rechnungserstellung" },
  { id: 3, text: "Digitale Abtretungserklärung" },
  { id: 4, text: "KI-gestützter PDF-Scanner" },
  { id: 5, text: "Multi-Mandanten-fähig" }
];

export const footerLinks = [
  { id: 1, text: "Impressum", href: "/impressum" },
  { id: 2, text: "Datenschutz", href: "/datenschutz" },
  { id: 3, text: "Barrierefreiheit", href: "/barrierefreiheit" }
];

export const impressumContent = {
  title: "Impressum",
  sections: [
    {
      heading: "Angaben gemäß § 5 TMG",
      content: "Autogutachter24 GmbH\nMusterstraße 123\n12345 Musterstadt\nDeutschland"
    },
    {
      heading: "Kontakt",
      content: "Telefon: +49 (0) 123 456789\nE-Mail: info@autogutachter24.de"
    },
    {
      heading: "Vertreten durch",
      content: "Geschäftsführer: Max Mustermann"
    },
    {
      heading: "Registereintrag",
      content: "Eintragung im Handelsregister\nRegistergericht: Amtsgericht Musterstadt\nRegisternummer: HRB 12345"
    },
    {
      heading: "Umsatzsteuer-ID",
      content: "Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:\nDE123456789"
    }
  ]
};

export const datenschutzContent = {
  title: "Datenschutzerklärung",
  sections: [
    {
      heading: "1. Datenschutz auf einen Blick",
      content: "Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen."
    },
    {
      heading: "2. Allgemeine Hinweise und Pflichtinformationen",
      content: "Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung."
    },
    {
      heading: "3. Datenerfassung auf dieser Website",
      content: "Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen."
    },
    {
      heading: "4. Ihre Rechte",
      content: "Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten."
    }
  ]
};

export const barrierefreiheitContent = {
  title: "Erklärung zur Barrierefreiheit",
  sections: [
    {
      heading: "Stand der Vereinbarkeit mit den Anforderungen",
      content: "Diese Website ist mit den Web Content Accessibility Guidelines (WCAG) 2.1 Level AA teilweise vereinbar."
    },
    {
      heading: "Nicht barrierefreie Inhalte",
      content: "Wir arbeiten kontinuierlich daran, die Barrierefreiheit unserer Website zu verbessern."
    },
    {
      heading: "Feedback und Kontakt",
      content: "Wenn Sie Probleme mit der Barrierefreiheit feststellen, kontaktieren Sie uns bitte unter: barrierefreiheit@autogutachter24.de"
    }
  ]
};
